import { render, staticRenderFns } from "./ScatterExample.vue?vue&type=template&id=37ecdad0&"
import script from "./ScatterExample.vue?vue&type=script&lang=js&"
export * from "./ScatterExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports